import LzDrawer from './drawer.vue';

LzDrawer.install = function(Vue) {
  Vue.component(LzDrawer.name, LzDrawer);
};

export default LzDrawer;
